export { Manual as ManualLayout } from './Manual';
